import { useState, useEffect } from "react"

/**
 * useTimeoutVisible — returns `true` after the given delay (ms)
 */
export function useTimeoutRender(delay: number = 3000) {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => setVisible(true), delay)
        return () => clearTimeout(timer)
    }, [delay])

    return visible
}
